<template>
	<div
		class="w-100 px-3 px-lg-0 d-flex flex-column flex-md-row align-items-center align-items-md-start justify-content-between">
		<!-- DATES -->
		<div class="h-100 d-none flex-column d-lg-flex mb-2 mb-lg-0 position-relative flex-item align-items-center">
			<div class="flex-item-container d-flex flex-column">
				<span class="body-strong text-primary-blue text-start">
					{{ store.state.content.planner_prestationsDates }}
				</span>
				<div class="d-flex flex-column d-lg-flex text-start body text-grey-900 mb-2 me-1">
					<span class="text-capitalize me-1">
						{{ store.state.content.planner_datePickerFrom }}
						{{ store.state.dates.BeginDate }}
					</span>
					<span>
						{{ store.state.content.planner_datePickerTill }}
						{{ store.state.dates.EndDate }}
					</span>
				</div>
			</div>
		</div>

		<!-- PARTICIPANTS -->
		<div
			class="h-100 d-none d-lg-flex flex-column text-start position-relative align-self-start align-self-md-center flex-item align-items-center border-start border-md-1">
			<div class="flex-item-container d-flex flex-column">
				<span class="body-strong text-primary-blue">
					{{ store.state.content.planner_prestationsParticipants }}</span>
				<p class="body text-grey-900">
					{{ store.state.participants.length }}
					{{ store.state.content.planner_prestationsPersons }}
				</p>
				<!-- <div
					class="d-none d-lg-flex border-end position-absolute h-100"
					style="top: 0; left: 0"
				></div> -->
			</div>
		</div>

		<!-- INCLUS -->
		<div :style="{
			visibility: store.state.packCode !== 'HS' ? 'visible' : 'hidden',
		}"
			class="h-100 d-flex flex-column position-relative align-self-start align-self-md-center flex-item align-items-center border-start border-md-1">
			<div class="flex-item-container d-flex flex-column">
				<span class="body-strong text-primary-blue">
					{{ store.state.content.planner_prestationsInclude }}</span>
				<Inclus :isDisplayPlaceholders="false" :variant="props.variant"></Inclus>
			</div>
		</div>

		<!-- FLEX -->
		<div
			class="h-100 col-12 col-lg-2 ps-4 d-flex flex-column position-relative flex-item align-items-center border-start border-md-1">
			<PaymentCondition 
			v-if="props.variant?.paymentCondition !== undefined" 
			:paymentCondition="props.variant.paymentCondition" 
			:displayTitle="false" 
			:cancellation-date="props.variant.cancelationUntil"/>
		</div>

		<!-- PRICE -->
		<div
			class="h-100 col-12 col-lg-2 d-flex flex-column align-items-end justify-content-center pe-md-3 position-relative">
			<!-- <Prices
				:isLoading="pricesLoadingSet.has(currentCacheKey)"
				:packCode="props.variant.packCode"
				:maxPromo="maxPromo"
				:crossedPrice="crossedPrice"
				:totalPrice="totalPrice"
				:perPrice="perPrice"
				:locale="store.getters.locale"
			/> -->
			<component
				:is="checkIfUkWebsite ? PricesPP : Prices"
				:isLoading="pricesLoadingSet.has(currentCacheKey)"
				:packCode="props.variant.packCode"
				:crossedPrice="crossedPrice" :totalPrice="totalPrice" :perPrice="perPrice" :maxPromo="maxPromo"
				:locale="store.getters.locale" 
				:totalParticipants="store.state.participants.length"
			></component>
		</div>
		<div class="col-lg-3 col-12 d-flex justify-content-end h-100 align-items-center">
			<div class="h-100 d-flex col-md-10 col-12 align-items-center justify-content-center position-relative popup-accommodation-btn">
				<SelectButton
					:accommodationOnly="accommodationOnly" 
					:variant="props.variant"
					:locale="store.getters.locale"
					:selectedQuantity="store.state.selectedPrestIds[props.variant.id]"
					:select_location="'prestationPopup'" 
					:disabled="isDisabledPrest" @selectClick="(id: string) => emit('select', id)"
					@dropdownClick="(obj: any) => emit('dropdownClick', obj)" 
					@clear="(id: string) => emit('clear', id)" 
					@dropdownSelect="({ newSelected, id }: { newSelected: number; id: string }) => emit('dropdownSelect', { newSelected, id })" />
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
import {
	computed,
	ComputedRef,
	watch,
} from "vue";

//import store from "@/vue/planning/store/store";
import Prices from "@/vue/planning/components/common/prices.vue";
import PricesPP from "@/vue/planning/components/common/pricesPP.vue";
import SelectButton from "@/vue/planning/components/result/selectBtn.vue";
import Inclus from "@/vue/planning/components/result/prestation/inclus.vue";
import {
	getPrestCrossedPrice,
	getPrestTotalPrice,
	// getPrestPerPrice,
	getPrestMaxPromo,
	getMaxPromo,
} from "@/logic/pricesAndDiscount";
import responsesCache from "@/vue/planning/state/responsesCache";
import pricesLoadingSet from "@/vue/planning/state/pricesLoadingSet";
import currentCacheKey from "@/vue/planning/computed/currentCacheKey";
import PaymentCondition from "@/vue/planning/components/result/prestation/PaymentCondition.vue"
import displayPrice from "@/displayPrice/displayPrice"
import getSiteFromDomain from "@/vue/planning/logic/getSiteFromDomain";

// Config
import flightPackCode from "@/config/flightPackCode"
import trainPackCode from "@/config/trainPackCode"
import { airportCodeMap } from "@/config/airportCodeMap"
import { trainStationCodeMap } from "@/config/trainStationCodeMap"

import { useStore } from "vuex"
const store = useStore();

interface Props {
	variant: any;
}
interface Emits {
	(e: "select", id: string): void;
	(e: "clear", id: string): void;
	(
		e: "dropdownSelect",
		selectedData: { newSelected: number; id: string }
	): void;
	(e: "dropdownClick", obj: any): void;
}

const props = withDefaults(defineProps<Props>(), {
	variant: {},
});
const emit = defineEmits<Emits>();

const checkIfUkWebsite = computed(() => {
	return false; // Wait for green light
	//return getSiteFromDomain(window.location.hostname) === "www.uk.travelski.com";
});

// Helper function to get origin the same way getWiypPrice does
const getOriginForLookup = (packCode: string): string => {
	const rawOrigin = store.state.flightOrigin ?? store.state.wiypDefaultFlightOrigin ?? "";

	if (!packCode) return 'NA';

	if (flightPackCode.includes(packCode)) {
		return airportCodeMap.has(rawOrigin) ? rawOrigin : Array.from(airportCodeMap.keys())[0] || 'NA';
	} else if (trainPackCode.includes(packCode)) {
		return trainStationCodeMap.has(rawOrigin) ? rawOrigin : Array.from(trainStationCodeMap.keys())[0] || 'NA';
	}
	return 'NA';
};

// Create a computed property to track the specific wiypCall data for this variant
// This ensures reactivity when wiypCall changes
const wiypCallData = computed(() => {
	const origin = getOriginForLookup(store.state.packCode);
	const familyComposition = store.state.participants.join('-');
	const packageCode = store.state.packCode;
	const packageId = props?.variant?.prestId;
	if (!packageId) return undefined;	
	return store.getters.getWiypCallByFamilyCompositionAndOriginAndPackageCodeAndId(
		familyComposition,
		origin,
		packageCode,
		packageId
	);
});

const accommodationOnly: ComputedRef<string | undefined> = computed(() => {
	const wiypData = wiypCallData.value;
	if(wiypData && wiypData.wiypPrices) {
		// Switched from prestIdFusion to prestIdSource to match the logic in virtual stock
		const accommodation = wiypData.wiypPrices.find((w: any) => w.prestId === props.variant.prestIdSource);
		if(accommodation && accommodation.accomPriceWiyp) {
			return accommodation.accomPriceWiyp;
		}
	}

	if (store.state.packCode != 'HS' && store.state.selectedPrestIds && Object.keys(store.state.selectedPrestIds).length > 0) {
		try {
			const price = store.state.prestMaps.prices[store.state.packCode][props.variant.id].priceAccommodationOnly;
			if (price) {
				return displayPrice(parseInt(price) * 100, store.getters.locale) ?? undefined;
			}
		}
		catch (e) {
			console.error(e);
		}
	}
	return undefined;
});

const crossedPrice: ComputedRef<number> = computed(() => {
	const wiypData = wiypCallData.value;
	if(wiypData && wiypData.wiypPrices) {
		// Switched from prestIdFusion to prestIdSource to match the logic in virtual stock
		const crossed = wiypData.wiypPrices.find((w: any) => w.prestId === props.variant.prestIdSource);
		if(crossed && crossed.publicPriceWiyp) {
			return crossed.publicPriceWiyp;
		}
	}
	if (!props.variant) return NaN;
	const pricesResponse = responsesCache.value.getResponse(
		"prices",
		currentCacheKey.value
	);
	return props.variant && getPrestCrossedPrice(props.variant, !!pricesResponse);
});

const perPrice: ComputedRef<number> = computed(() => {
	return NaN;
	// return props.variant && getPrestPerPrice(props.variant, this.participants.length)
});

const totalPrice: ComputedRef<number> = computed(() => {
	const wiypData = wiypCallData.value;
	if(wiypData && wiypData.wiypPrices) {
		// Switched from prestIdFusion to prestIdSource to match the logic in virtual stock
		const total = wiypData.wiypPrices.find((w: any) => w.prestId === props.variant.prestIdSource);
		if(total && total.sellingPriceWiyp) {
			return total.sellingPriceWiyp;
		}
	}
	return props.variant && getPrestTotalPrice(props.variant);
});

const isDisabledPrest: ComputedRef<boolean> = computed(() => {
	return totalPrice.value <= 0;
});

const maxPromo: ComputedRef<number> = computed(() => {
	const wiypData = wiypCallData.value;
	if(wiypData && wiypData.wiypPrices) {
		// Switched from prestIdFusion to prestIdSource to match the logic in virtual stock
		const promoPrice = wiypData.wiypPrices.find((w: any) => w.prestId === props.variant.prestIdSource);
		if(promoPrice && promoPrice.publicPriceWiyp && promoPrice.sellingPriceWiyp) {
			return getMaxPromo(Math.round(( promoPrice.publicPriceWiyp - promoPrice.sellingPriceWiyp) / promoPrice.publicPriceWiyp * 100));
		}
	}
	return props.variant && getPrestMaxPromo(props.variant);
});

// Watch wiypCall changes to ensure computed properties recompute
// Watching both the store state and the computed property ensures reactivity
watch(
	[
		() => store.state.wiypCall,
		() => store.state.participants,
		() => store.state.flightOrigin,
		() => store.state.packCode,
		() => store.state.dates,
		() => props.variant,
	],
	() => {
		// Force recomputation by accessing the computed property
		wiypCallData.value;
	},
	{ deep: true }
);

</script>

<style scoped>
.flex-item {
	flex: 1 1 auto;
	position: relative;
}

@media (max-width: 1400px) {
  .popup-accommodation-btn {
    min-width: 16vw
  }

  .accommodation-btn button{
    margin-right: .20rem !important
  }
}

@media (max-width: 768px) {
	.flex-item {
		border: none !important;
		padding-left: 0px !important;
	}
}
</style>
